import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const BASE  = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const token = () => localStorage.getItem('kialuga_token');

function diasRestantes(prazo) {
  if (!prazo) return null;
  return Math.max(0, Math.ceil((new Date(prazo).getTime() - Date.now()) / (1000 * 60 * 60 * 24)));
}

export default function PainelFotosPendentes() {
  const [produtos, setProdutos] = useState([]);
  const [loading,  setLoading]  = useState(true);

  useEffect(() => {
    fetch(`${BASE}/fornecedor/anuncios/pending-photos`, {
      headers: { Authorization: `Bearer ${token()}` },
    })
      .then(r => r.json())
      .then(d => { if (d.sucesso) setProdutos(d.produtos); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  if (loading || produtos.length === 0) return null;

  const urgentes = produtos.filter(p => (diasRestantes(p.prazo_fotos) ?? 99) <= 4);
  const normais  = produtos.filter(p => (diasRestantes(p.prazo_fotos) ?? 99) > 4);

  const ItemProduto = ({ p, urgente }) => {
    const dias = diasRestantes(p.prazo_fotos);
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        background: '#fff', border: `1px solid ${urgente ? '#fecaca' : '#fde68a'}`,
        borderRadius: '12px', padding: '12px 14px', gap: '12px' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <p style={{ fontSize: '14px', fontWeight: '600', color: '#111827',
            margin: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {p.titulo}
          </p>
          <p style={{ fontSize: '12px', color: '#6b7280', margin: '2px 0 0' }}>{p.category}</p>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexShrink: 0 }}>
          <span style={{ fontSize: '12px', fontWeight: '600',
            color: urgente ? '#dc2626' : '#92400e', whiteSpace: 'nowrap' }}>
            {dias === 0 ? 'Hoje!' : `${dias}d`}
          </span>
          <Link to={`/fornecedor/anuncios/${p.id}/fotos`}
            style={{ fontSize: '12px', padding: '6px 12px', borderRadius: '8px', border: 'none',
              cursor: 'pointer', fontWeight: '600', textDecoration: 'none',
              background: urgente ? '#dc2626' : '#f59e0b',
              color: '#fff', whiteSpace: 'nowrap' }}>
            Adicionar foto
          </Link>
        </div>
      </div>
    );
  };

  return (
    <div style={{ background: '#fffbeb', border: '1px solid #fde68a',
      borderRadius: '20px', padding: '18px 18px', marginBottom: '20px' }}>

      {/* Cabeçalho */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '14px' }}>
        <div>
          <h3 style={{ fontSize: '14px', fontWeight: '700', color: '#78350f', margin: 0 }}>
            📷 {produtos.length} produto(s) sem foto
          </h3>
          <p style={{ fontSize: '12px', color: '#92400e', marginTop: '3px' }}>
            Produtos sem foto são invisíveis para os clientes. Adiciona fotos para os activar.
          </p>
        </div>
      </div>

      {/* Urgentes — ≤ 4 dias */}
      {urgentes.length > 0 && (
        <div style={{ marginBottom: normais.length > 0 ? '12px' : 0 }}>
          <p style={{ fontSize: '11px', fontWeight: '700', color: '#dc2626',
            textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '8px' }}>
            ⚠ Prazo a expirar
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {urgentes.map(p => <ItemProduto key={p.id} p={p} urgente />)}
          </div>
        </div>
      )}

      {/* Normais */}
      {normais.length > 0 && (
        <div>
          {urgentes.length > 0 && (
            <p style={{ fontSize: '11px', fontWeight: '700', color: '#92400e',
              textTransform: 'uppercase', letterSpacing: '0.06em', margin: '12px 0 8px' }}>
              Outros pendentes
            </p>
          )}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {normais.slice(0, 3).map(p => <ItemProduto key={p.id} p={p} urgente={false} />)}
          </div>
          {normais.length > 3 && (
            <Link to="/fornecedor/anuncios?filtro=a_aguardar_fotos"
              style={{ display: 'block', textAlign: 'center', fontSize: '12px',
                fontWeight: '600', color: '#92400e', marginTop: '10px',
                textDecoration: 'none' }}>
              Ver todos os {normais.length} produtos pendentes →
            </Link>
          )}
        </div>
      )}
    </div>
  );
}
